import { render, staticRenderFns } from "./Walkthrough.vue?vue&type=template&id=1cf6c9c7&scoped=true&"
import script from "./Walkthrough.vue?vue&type=script&lang=js&"
export * from "./Walkthrough.vue?vue&type=script&lang=js&"
import style0 from "./Walkthrough.vue?vue&type=style&index=0&id=1cf6c9c7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cf6c9c7",
  null
  
)

export default component.exports